import type { PanderrButton } from "../types";

function escapeHtml(value: string): string {
  return String(value || "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

export function renderPanderrButton(button: PanderrButton): string {
  const variant = button.variant ?? "primary";

  const className =
    variant === "secondary"
      ? "panderr-button panderr-button-secondary"
      : variant === "text"
        ? "panderr-button panderr-button-text"
        : "panderr-button panderr-button-primary";

  const hrefFieldAttribute = button.hrefField
    ? ` data-panderr-href-field="${escapeHtml(button.hrefField)}"`
    : "";

  return `
    <a
      class="${className}"
      href="${escapeHtml(button.href)}"
      data-panderr-component="button"
      data-panderr-button-variant="${variant}"${hrefFieldAttribute}
    >
      ${escapeHtml(button.label)}
    </a>
  `;
}
